import { useRouter } from 'next/router'
import useSeti from './useSeti'
import { AMENITIES } from '../SearchForm/constants'

export default function useSEMSearchHeadlineExperiment(
  setiName: string,
  shouldFireImpression = true
) {
  const { query } = useRouter()
  const { SEMSearch, SEMSEARCH } = query
  const semSearchParam = SEMSearch || SEMSEARCH
  const semSearch = (semSearchParam as string | undefined)?.toUpperCase()
  const amenityHeadline = AMENITIES[semSearch as keyof typeof AMENITIES]
  const isSEMHotelsSeti =
    useSeti(setiName, shouldFireImpression && amenityHeadline !== undefined) ===
    'VARIANT'

  return isSEMHotelsSeti && amenityHeadline ? amenityHeadline : null
}
